// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"1cfa4d17","879":"a3c0342c"}[chunkId] + ".chunk.js";
};